export const IMPERSONATION_SET_STATE = "IMPERSONATION_SET_STATE";
export const IMPERSONATION_RESET_STATE = "IMPERSONATION_RESET_STATE";
